import React, { useMemo, useState } from 'react'
import CreditButton from './credit-button'
import PaypalButton from './paypal-button'
import KlarnaButton from './klarna-button'
import AfterPayButton from './afterpay-button'
import ApplepayButton from './applepay-button'
import DisableButton from './disable-button'

export default props => {
    const { payMethodInfo, orderTotal, country, paying, payHandle, onPaymethod, count, clickHandle } = props

    const paypal = useMemo(() => {
        return <PaypalButton {...props} onPaymethod={onPaymethod} eventClick={clickHandle}/>
    }, [])

    const applepay = useMemo(() => {
        return <ApplepayButton {...props} onPaymethod={onPaymethod}/>
    }, [orderTotal?.amount, orderTotal?.currency, country])

    const getButton = () => {
        switch (payMethodInfo?.type) {
            case '1':
                return paypal
            case '27':
                return <KlarnaButton {...props} onPaymethod={onPaymethod} onClick={payHandle} paying={paying} onPay={payHandle} />
            case '28':
                return <AfterPayButton {...props} onPaymethod={onPaymethod} onClick={payHandle} paying={paying} onPay={payHandle} /> 
            case '8':
            case '30':
                return <CreditButton {...props} onPaymethod={onPaymethod} onClick={payHandle} paying={paying} onPay={payHandle} />
            case '32':
                return applepay
            default:
                return null
        }
    }

    const Button = getButton()
    return count > 0? Button: <DisableButton onPaymethod={onPaymethod}/>
}